import React, { useEffect } from 'react';
import './Toast.css';

// `action` ({ label, onClick }) adds a button such as Undo and keeps the toast up longer.
export default function Toast({ message, type = 'success', onClose, duration, action = null }) {
  const timeout = duration ?? (action ? 8000 : 3000);
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout, onClose]);

  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-content">
        <span className="toast-icon">
          {type === 'success' ? '✓' : type === 'error' ? '✕' : 'ℹ'}
        </span>
        <span className="toast-message">{message}</span>
      </div>
      {action && (
        <button
          className="toast-action"
          onClick={() => {
            onClose();
            action.onClick();
          }}
        >
          {action.label}
        </button>
      )}
      <button className="toast-close" onClick={onClose}>×</button>
    </div>
  );
}
